var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#00C853"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2616 9H9.73837C7.67372 9 6 10.5768 6 12.522V17.478C6 19.4232 7.67372 21 9.73837 21H20.2616C22.3263 21 24 19.4232 24 17.478V12.522C24 10.5768 22.3263 9 20.2616 9ZM17.7334 15.2411L12.8113 17.4528C12.6802 17.5117 12.5287 17.4216 12.5287 17.2847V12.7232C12.5287 12.5844 12.6842 12.4944 12.8156 12.5572L17.7377 14.907C17.884 14.9769 17.8815 15.1746 17.7334 15.2411Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.c1d3b5285f9353c0a168c8e827811693.svg";
export { ForwardRef as ReactComponent };